import React from 'react';
import { APP_NAME } from '../config/appConfig';
import { useDocumentMetadata } from '../hooks/useDocumentMetadata';

const policySections = [
  {
    title: 'Data Handling',
    body:
      'Demo inputs submitted through the platform are processed to generate feature responses. In a production deployment, uploaded files and chat history should be governed by retention, encryption, and audit policies.',
  },
  {
    title: 'AI-Assisted Output',
    body:
      'The application uses AI-generated responses to support diagnostics, wellness planning, and conversational assistance. Output should be reviewed by qualified professionals before any clinical decision-making.',
  },
  {
    title: 'Environment Configuration',
    body:
      'Service credentials, model configuration, and deployment endpoints should be supplied through environment variables rather than hardcoded into the client or server.',
  },
];

const PrivacyPolicy: React.FC = () => {
  useDocumentMetadata(
    'Privacy Policy',
    `Review privacy and data handling guidance for ${APP_NAME}.`
  );

  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="container mx-auto max-w-4xl px-6">
        <div className="rounded-3xl bg-white p-10 shadow-sm ring-1 ring-slate-200">
          <h1 className="text-4xl font-bold text-slate-900">Privacy Policy</h1>
          <p className="mt-4 text-lg text-slate-600">
            {APP_NAME} is presented as a demonstration platform, but it is designed with production-minded privacy considerations in view.
          </p>

          <div className="mt-8 space-y-6">
            {policySections.map((section) => (
              <section key={section.title} className="rounded-2xl bg-slate-50 p-6">
                <h2 className="text-xl font-semibold text-slate-900">{section.title}</h2>
                <p className="mt-3 text-slate-600">{section.body}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
